module.exports = __webpack_public_path__ + "img/loding.c8761a68.gif";